// extracted by mini-css-extract-plugin
module.exports = {"uploadError":"upload_uploadError__1yCX4","downloaded":"upload_downloaded__1et0w"};